export { RdProjectDetail } from './RdProjectDetail';
